import React, { Fragment } from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import CommentList from './CommentList';

import Spacer from 'components/ui/Spacer';

const FormTitle = styled.span`
  font-size: 20px;
  font-family: 'Circular-Bold';
`;

const StyledSectionContainer = styled.div`
  margin-top: 2rem;
`;

const VendorCommentsContainer = ({ comments }) => {
  return (
    <Fragment>
      <StyledSectionContainer>
        <Spacer mb={0.3}>
          <FormTitle>
            {getTranslatedString('landlordPortal.maintenance.comments.vendorNotes')}
          </FormTitle>
        </Spacer>
      </StyledSectionContainer>
      <CommentList comments={comments} />
    </Fragment>
  );
};

export default VendorCommentsContainer;
